import Splide from "@splidejs/splide";

window.addEventListener('load', () => {
    const aanbod_slider = document.querySelector<HTMLElement>(".splide.header-slider");
    if(!aanbod_slider) return;

    const slider = new Splide(aanbod_slider, {
        type:"loop",
        perPage: 1,
        arrows:false,
        autoplay: true,
        interval:4000,
        pagination: true,
    })
    slider.mount();

});
